import React from 'react';
import TextField from '../../../../Forms/TextField';

const HomeHeroForm = () => {
    return (
        <div className="mt-1">
            <p>
                For the Header, you have the option to use Accent field or not. Using just the "Home Header" the text
                will all be the same color. If you use all 3 the accent will be in the middle. Omitting the "Home
                Header" or "... End" fields will put the accent at the beginning or end respectively.
            </p>
            <p>For the Home Header Image, enter URL with 'https://cdn.igrad.com/' domain.</p>
            <TextField label="Home Header" placeholder="Enter Header text" type="text" name="homeHeroHeader" />
            <TextField
                label="Home Header Accent"
                placeholder="Enter Header text"
                type="text"
                name="homeHeroHeaderAccent"
            />
            <TextField label="Home Header End" placeholder="Enter Header text" type="text" name="homeHeroHeaderEnd" />
            <hr />
            <TextField label="Home Subheader" placeholder="Enter Header text" type="text" name="homeHeroSubheader" />
            <TextField 
                label="Home Header Image" 
                inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                placeholder="Enter URL with 'https://cdn.igrad.com/'/' domain" 
                type="text" 
                name="homeHeroImage" />
        </div>
    );
};

export default HomeHeroForm;
